import axios from "../../privateApi";

export type EvoBuilderSubEvent =
  | "chainRecommendation"
  | "save"
  | "detailedPlayerView"
  | "download";

type DetailedPlayerViewEvent = {
  event: "detailed-player-view";
  resourceId: number;
};

type EvoBuilderPlayerEvent = {
  event: "evo-builder-player";
  resourceId: number;
  playerPathId: string;
  pathwayPath: number[][];
  subEvent: EvoBuilderSubEvent;
};

type SbcSolutionEvent = {
  event: "sbc-solution";
  sbcSetId: number;
  sbcId: number;
};

export type TrackingEvent =
  | DetailedPlayerViewEvent
  | EvoBuilderPlayerEvent
  | SbcSolutionEvent;

// Fire-and-forget trending tracking. The endpoint guards userId through the
// AuthGuard, so an anonymous request would 401 and bounce the user to /login —
// skip when there is no token. Errors are swallowed so tracking never disrupts
// the flow it instruments.
export const postEvent = async (event: TrackingEvent) => {
  if (!localStorage.getItem("access_token")) return;
  try {
    return await axios.post("/events", event);
  } catch {
    console.error("Error posting event", event);
  }
};
